import Vue from "vue";
import VueRouter from "vue-router";
import ForgotPassword from "views/ForgotPassword";
import Login from "views/Login";
import Register from "views/Register";
import ResetPassword from "views/ResetPassword";

Vue.use(VueRouter);

export default new VueRouter({
	routes: [
		{
			path: "/",
			name: "Login",
			component: Login,
			props: {
				hideRegistration: $rec.site.hideregistrationform,
				target: decodeURIComponent($rec.loginTarget)
			}
		},
		{
			path: "/forgotpassword",
			name: "ForgotPassword",
			component: ForgotPassword,
			props: {
				forgotSuccessBody: decodeURIComponent($rec.site.forgotsent)
			}
		},
		{
			path: "/resetpassword/:token",
			name: "ResetPassword",
			component: ResetPassword,
			props: true
		},
		{
			path: "/register",
			name: "Register",
			component: Register,
			meta: { hideSplash: true },
			props: (route) => ({
				params: route.query,
				partner: route.query.partner === "1",
				privacyUrl: $rec.privacyEnabled ? $rec.privacyUrl : "",
				registerHeading: decodeURIComponent($rec.site.registerheading),
				registerBody: decodeURIComponent($rec.site.registerbody),
				registerSuccessBody: decodeURIComponent($rec.site.regsuccess)
			})
		},
		{
			path: "/!/register",
			redirect: { name: "Register" }
		},
		{
			path: "*",
			redirect: { name: "Login" }
		}
	]
});
